import React from "react";
import { Typography, Button } from "@material-ui/core";
export default function Footer() {
  return (
    <div
      style={{
        fontSize: "20px",
        color: "white",
        // borderTop: "1px solid #E7E7E7",
        // borderRight: "1px solid #E7E7E7",
        textAlign: "center",
        padding: "20px",
        position: "fixed",
        left: "0",
        bottom: "0",
        height: "20px"
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
        <Button style={{ marginLeft: 0, minHeight: 0, minWidth: 0, textTransform: "none" }}>
          <a href={"mailto:jollygoodlife.dev@gmail.com"}>Email Us</a>
        </Button>
        <Typography style={{ color: "#000" }}>|</Typography>
        <Button style={{ marginLeft: 0, minHeight: 0, minWidth: 0, textTransform: "none" }}>
          <a href={"https://ydesmundy.wixsite.com/jollygoodlife/contact"}>Feedback Form</a>
        </Button>
      </div>
    </div>
  );
}
